// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_cf3ff079","iconWrap":"_b41a2192","icon":"_c6afc4e6","heartButton":"_1858011"};